import { QueryParams } from "@/models/query-params.model";
import { Observable } from "rxjs";
import api from "../api-config/rxjs-config";

export class ActivityRest {
  create(data: any): Observable<any> {
    const url: string = `/activities`;
    return api.post(url, data);
  }
  update(id: string, data: any): Observable<any> {
    const url: string = `/activities/${id}`;
    return api.put(url, data);
  }
  getById(id: string): Observable<any> {
    const url: string = `/activities/${id}`;
    return api.get(url);
  }

  getAll(params: QueryParams): Observable<any> {
    const url: string = `/activities`;
    return api.get(url, params);
  }

  delete(id: string): Observable<any> {
    const url: string = `/activities/${id}`;
    return api.delete(url);
  }

  getStudentActivitiesById(activityId: string): Observable<any> {
    const url: string = `/student-activities/${activityId}`;
    return api.get(url);
  }

  getStudentActivities(): Observable<any> {
    const url: string = `/student-activities`;
    return api.get(url);
  }

  getStudentsByActivityId(id: string, params:QueryParams): Observable<any> {
    const url: string = `/activities/${id}/student-activities`;
    return api.get(url, params);
  }

  sendFeedback(id: string, data: any): Observable<any> {
    const url: string = `/student-activities/${id}/feedback`;
    return api.put(url, data);
  }

  getStudentActivitiesByClass(classroomId: string, params:QueryParams): Observable<any> {
    const url: string = `/classroom/${classroomId}/student-activities`;
    return api.get(url, params);
  }

  updateStudentActivity(activityId: string, data: FormData) {
    const url: string = `/student-activities/${activityId}`;
    return api.put(url, data);
  }
}
